const CountBadge = ({
  count,
  'aria-hidden': ariaHidden,
}: {
  count: number;
  'aria-hidden'?: boolean | 'true' | 'false';
}) => (
  <span
    aria-hidden={ariaHidden}
    className="rounded-2 w-max bg-brand-neutral-100 px-2.5 py-1 font-body font-bold text-xs leading-[1.5] text-brand-neutral-900"
  >
    {count}
  </span>
);

export default CountBadge;
